/**
 * O que o quadro "Realizações Destaque de <fase>" mostra quando a aba escolhida não tem realização.
 *
 * - `nenhum`: a lista ainda está carregando, a fase não tem tipo, ou há realizações (a lista ocupa o quadro).
 * - `fase-sem-realizacao`: fase que não está aberta (em apreciação ou encerrada) ou a fase especial sem
 *   Realizações Destaque. Mostra "Não há Realizações Destaque nesta fase.".
 * - `fase-aberta`: fase aberta sem realização na aba. Mostra os textos de sempre: convite para cadastrar,
 *   "Você ainda não foi incluído…" ou "Não existem realizações apreciadas até o momento.".
 *
 * Antes, toda fase que não estava aberta caía num `return` vazio e o quadro ficava em branco, inclusive a
 * fase especial, cuja mensagem nunca chegava a aparecer.
 */

/** Fase "Nível 1 - Agosto" do ciclo 2S2025, que não teve Realizações Destaque. */
export const PHASE_WITHOUT_REALIZATIONS_ID = '68af4da8458e527eaa788503';

export type EmptyStateKind = 'nenhum' | 'fase-sem-realizacao' | 'fase-aberta';

export interface EmptyStateInput {
  tab: 'cadastrada' | 'participando';
  myTasks?: unknown[] | null;
  otherTasks?: unknown[] | null;
  stage?: { _id?: string; type?: string; status?: string } | null;
}

export function resolveEmptyState({ tab, myTasks, otherTasks, stage }: EmptyStateInput): EmptyStateKind {
  if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !stage?.type) return 'nenhum';

  const tasksDaAba = tab === 'cadastrada' ? myTasks : otherTasks;
  if (tasksDaAba.length > 0) return 'nenhum';

  if (stage.status !== 'open' || stage._id === PHASE_WITHOUT_REALIZATIONS_ID) return 'fase-sem-realizacao';

  return 'fase-aberta';
}
